import {NumberFormatProps} from "react-number-format";

export const numberFormatProps: Partial<NumberFormatProps> = {
    decimalScale: 2,
    decimalSeparator: ",",
    thousandSeparator: false,
};